module.exports = function getResource(label, vars = []) {
    const resources = {
        selectUpToSamples: `Sélectionnez jusqu’à ${vars[0]} échantillon(s)`,
        done: 'Terminé'
    };

    return resources[label];
};
